/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseTemplateDto } from '../models/base-template-dto';
import { BaseWorkPackageDto } from '../models/base-work-package-dto';
import { bulkAnalyzeDefects } from '../fn/focoos-ai/bulk-analyze-defects';
import { BulkAnalyzeDefects$Params } from '../fn/focoos-ai/bulk-analyze-defects';
import { createModel } from '../fn/focoos-ai/create-model';
import { CreateModel$Params } from '../fn/focoos-ai/create-model';
import { deleteAnalyzedImage } from '../fn/focoos-ai/delete-analyzed-image';
import { DeleteAnalyzedImage$Params } from '../fn/focoos-ai/delete-analyzed-image';
import { getModel } from '../fn/focoos-ai/get-model';
import { GetModel$Params } from '../fn/focoos-ai/get-model';
import { listAnalyzedImages } from '../fn/focoos-ai/list-analyzed-images';
import { ListAnalyzedImages$Params } from '../fn/focoos-ai/list-analyzed-images';
import { listFocoosModels } from '../fn/focoos-ai/list-focoos-models';
import { ListFocoosModels$Params } from '../fn/focoos-ai/list-focoos-models';
import { listModels } from '../fn/focoos-ai/list-models';
import { ListModels$Params } from '../fn/focoos-ai/list-models';
import { ModelInfo } from '../models/model-info';
import { ModelPreview } from '../models/model-preview';
import { WorkPackageAnalyzedImageDtoPage } from '../models/work-package-analyzed-image-dto-page';

@Injectable({ providedIn: 'root' })
export class FocoosAiApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listFocoosModels()` */
  static readonly ListFocoosModelsPath = '/v0/FocoosAI/focoos-models';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listFocoosModels()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFocoosModels$Response(params?: ListFocoosModels$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelPreview>>> {
    return listFocoosModels(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listFocoosModels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFocoosModels(params?: ListFocoosModels$Params, context?: HttpContext): Observable<Array<ModelPreview>> {
    return this.listFocoosModels$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ModelPreview>>): Array<ModelPreview> => r.body)
    );
  }

  /** Path part for operation `listModels()` */
  static readonly ListModelsPath = '/v0/FocoosAI/models';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listModels()` instead.
   *
   * This method doesn't expect any request body.
   */
  listModels$Response(params?: ListModels$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelPreview>>> {
    return listModels(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listModels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listModels(params?: ListModels$Params, context?: HttpContext): Observable<Array<ModelPreview>> {
    return this.listModels$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ModelPreview>>): Array<ModelPreview> => r.body)
    );
  }

  /** Path part for operation `getModel()` */
  static readonly GetModelPath = '/v0/FocoosAI/model-info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getModel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModel$Response(params: GetModel$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelInfo>> {
    return getModel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getModel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModel(params: GetModel$Params, context?: HttpContext): Observable<ModelInfo> {
    return this.getModel$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelInfo>): ModelInfo => r.body)
    );
  }

  /** Path part for operation `createModel()` */
  static readonly CreateModelPath = '/v0/FocoosAI/model';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createModel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModel$Response(params: CreateModel$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseTemplateDto>> {
    return createModel(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createModel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModel(params: CreateModel$Params, context?: HttpContext): Observable<BaseTemplateDto> {
    return this.createModel$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseTemplateDto>): BaseTemplateDto => r.body)
    );
  }

  /** Path part for operation `bulkAnalyzeDefects()` */
  static readonly BulkAnalyzeDefectsPath = '/v0/FocoosAI';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkAnalyzeDefects()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkAnalyzeDefects$Response(params: BulkAnalyzeDefects$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BaseWorkPackageDto>>> {
    return bulkAnalyzeDefects(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkAnalyzeDefects$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkAnalyzeDefects(params: BulkAnalyzeDefects$Params, context?: HttpContext): Observable<Array<BaseWorkPackageDto>> {
    return this.bulkAnalyzeDefects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BaseWorkPackageDto>>): Array<BaseWorkPackageDto> => r.body)
    );
  }

  /** Path part for operation `listAnalyzedImages()` */
  static readonly ListAnalyzedImagesPath = '/v0/FocoosAI/analyzed-images';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAnalyzedImages()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAnalyzedImages$Response(params: ListAnalyzedImages$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageAnalyzedImageDtoPage>> {
    return listAnalyzedImages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAnalyzedImages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAnalyzedImages(params: ListAnalyzedImages$Params, context?: HttpContext): Observable<WorkPackageAnalyzedImageDtoPage> {
    return this.listAnalyzedImages$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageAnalyzedImageDtoPage>): WorkPackageAnalyzedImageDtoPage => r.body)
    );
  }

  /** Path part for operation `deleteAnalyzedImage()` */
  static readonly DeleteAnalyzedImagePath = '/v0/FocoosAI/delete/analyzed-images';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAnalyzedImage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteAnalyzedImage$Response(params: DeleteAnalyzedImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAnalyzedImage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAnalyzedImage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteAnalyzedImage(params: DeleteAnalyzedImage$Params, context?: HttpContext): Observable<void> {
    return this.deleteAnalyzedImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
